export const NAVIGATION_GROUP_STORAGE_KEY = 'atmwater.admin.navigation.collapsed-groups.v1';

const uniqueStrings = (values) => Array.from(new Set(
  (Array.isArray(values) ? values : []).filter((value) => typeof value === 'string')
));

export const readCollapsedNavigationGroups = (storage, validKeys) => {
  try {
    const parsed = JSON.parse(storage?.getItem(NAVIGATION_GROUP_STORAGE_KEY) || '[]');
    const allowed = new Set(uniqueStrings(validKeys));
    return uniqueStrings(parsed).filter((key) => allowed.has(key));
  } catch (error) {
    return [];
  }
};

export const writeCollapsedNavigationGroups = (storage, keys) => {
  try {
    storage?.setItem(NAVIGATION_GROUP_STORAGE_KEY, JSON.stringify(uniqueStrings(keys)));
    return true;
  } catch (error) {
    return false;
  }
};

export const matchesNavigationPath = (pathname, itemPath) => {
  const currentPath = String(pathname || '/').split('?')[0].split('#')[0];
  if (itemPath === '/firmware/upgrade') return currentPath.startsWith('/firmware/');
  return itemPath === '/'
    ? currentPath === '/'
    : currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);
};

export const ensureActiveGroupExpanded = (collapsedKeys, groups, pathname) => {
  const activeGroup = (groups || []).find((group) => (
    (group.items || []).some((item) => matchesNavigationPath(pathname, item.path))
  ));
  return activeGroup
    ? uniqueStrings(collapsedKeys).filter((key) => key !== activeGroup.key)
    : uniqueStrings(collapsedKeys);
};

export const toggleCollapsedNavigationGroup = (collapsedKeys, groupKey) => {
  const current = uniqueStrings(collapsedKeys);
  return current.includes(groupKey)
    ? current.filter((key) => key !== groupKey)
    : [...current, groupKey];
};
